import { PageLayout } from '@/components/feature/PageLayout';

const seo = {
  title: 'Mentions légales | Volet Charleroi',
  description: 'Mentions légales du site Volet Charleroi. Informations sur l\'éditeur, l\'hébergement et les conditions d\'utilisation du site.',
  canonicalUrl: '/mentions-legales/',
  noindex: true,
};

export default function MentionsLegalesPage() {
  return (
    <PageLayout seo={seo} showDevisForm={false}>
      <section className="py-14 md:py-20 bg-background-50">
        <div className="max-w-3xl mx-auto px-4 md:px-6">
          <h1 className="text-3xl md:text-4xl font-heading font-bold text-foreground-700 mb-8">
            Mentions légales
          </h1>

          <div className="space-y-8 text-sm md:text-base text-foreground-600 leading-relaxed">
            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">1. Éditeur du site</h2>
              <p className="mb-2">
                Le site internet <strong>volet-charleroi.be</strong> est édité par :
              </p>
              <ul className="list-disc pl-5 space-y-1">
                <li>Entreprise : Volet Charleroi</li>
                <li>Adresse : 6000 Charleroi, Belgique</li>
                <li>Téléphone : <a href="tel:+3280020410" className="text-accent-500 hover:text-accent-600 underline">0800 20 410</a></li>
                <li>Email : <a href="mailto:info@volet-charleroi.be" className="text-accent-500 hover:text-accent-600 underline">info@volet-charleroi.be</a></li>
                <li>Numéro d'entreprise (BCE) : Disponible sur demande</li>
              </ul>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">2. Responsable de la publication</h2>
              <p>
                Le responsable de la publication du site est le gérant de l'entreprise Volet Charleroi, joignable à l'adresse email <a href="mailto:info@volet-charleroi.be" className="text-accent-500 hover:text-accent-600 underline">info@volet-charleroi.be</a>.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">3. Hébergement</h2>
              <p>
                Le site est hébergé par Readdy.ai, une plateforme de création de sites internet.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">4. Propriété intellectuelle</h2>
              <p>
                L'ensemble du contenu du site (textes, images, logo, structure) est la propriété exclusive de Volet Charleroi. Toute reproduction, même partielle, est interdite sans autorisation préalable.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">5. Limitation de responsabilité</h2>
              <p>
                Volet Charleroi s'efforce de fournir des informations exactes et à jour sur son site. Toutefois, l'entreprise ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises à disposition sur ce site. En conséquence, Volet Charleroi décline toute responsabilité pour toute imprécision, inexactitude ou omission portant sur des informations disponibles sur ce site.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">6. Liens hypertextes</h2>
              <p>
                Le site peut contenir des liens vers d'autres sites. Volet Charleroi n'exerce aucun contrôle sur ces sites et décline toute responsabilité quant à leur contenu.
              </p>
            </section>

            <section>
              <h2 className="text-lg font-heading font-semibold text-foreground-700 mb-3">7. Droit applicable</h2>
              <p>
                Les présentes mentions légales sont régies par le droit belge. Tout litige relatif à l'utilisation du site sera soumis à la compétence exclusive des tribunaux de l'arrondissement judiciaire de Charleroi.
              </p>
            </section>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}